import PropTypes from 'prop-types';
import React from 'react';

import { populateFormat, breakFormat } from '@togglecorp/fujs';
import { convertDateAccToLanguage, amPmToNepali } from '#rsu/common';
import styles from './styles.scss';

const propTypes = {
    className: PropTypes.string,

    /**
     * Timestamp
     */
    date: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
        PropTypes.instanceOf(Date),
    ]),
    /**
     * Options
     */
    mode: PropTypes.string,

    emptyComponent: PropTypes.func,
};

const defaultProps = {
    className: '',
    date: undefined,
    mode: 'dd-MM-yyyy',

    emptyComponent: () => '-',
};

/**
 * Show timestamp in Human Readable Format
 */
export default class FormattedDate extends React.PureComponent {
    static propTypes = propTypes;

    static defaultProps = defaultProps;

    static formatDate = (date, mode, language) => (
        populateFormat(breakFormat(mode), date)
            .map((e, i) => {
                const key = String(i);
                if (e.type === 'date') {
                    return (
                        <span
                            className="date"
                            key={key}
                        >
                            {language === undefined
                                ? e.value
                                : convertDateAccToLanguage(e.value, language)}
                        </span>
                    );
                }
                if (e.type === 'time') {
                    return (
                        <span
                            className="time"
                            key={key}
                        >
                            {language === undefined
                                ? e.value
                                : amPmToNepali(e.value, language)}
                        </span>
                    );
                }
                return (
                    <span
                        className="separator"
                        key={key}
                    >
                        {e.value}
                    </span>
                );
            })
    );

    render() {
        const {
            date,
            mode,
            className,
            language,
            emptyComponent: Empty,
        } = this.props;

        const containerClassName = [
            className,
            'formatted-date',
            styles.formattedDate,
        ].join(' ');

        if (!date) {
            return (
                <div className={containerClassName}>
                    {Empty && <Empty />}
                </div>
            );
        }
        const children = FormattedDate.formatDate(new Date(date), mode, language);
        return (
            <>
                {
                    typeof date === 'number'
                        ? (
                            <time>
                                {children}
                            </time>
                        )
                        : (
                            <p className={containerClassName}>
                                {JSON.stringify(date).split('T')[0].replaceAll('"', '')}
                            </p>
                        )
                }
            </>

        );
    }
}
